import { memo, useCallback } from "react";

import { TextField } from "ui/components/TextField/TextField";
import { DatePicker } from "ui/components/DatePicker";
import { FleetFireExtinguisherSearchFormValues } from "services/api/fleet/vehicles/fireextinguishers/types";
import { FireExtinguisherSearchFiltersProps } from "./types";

import { useTranslate } from "helpers";

const initialForm: FleetFireExtinguisherSearchFormValues = {
  search: "",
  expirationDateFrom: null,
  expirationDateTo: null,
  status: "",
};

const FireExtinguisherSearchFilters: React.FC<
  FireExtinguisherSearchFiltersProps
> = (props) => {
  const { formValues, onSearchChange } = props;
  const { t } = useTranslate();

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onSearchChange({ ...formValues, search: e.target.value });
  };

  const handleDateChange = (name: string, value: Date | null) => {
    onSearchChange({ ...formValues, [name]: value });
  };

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialForm);
  }, [onSearchChange]);

  return (
    <>
      <div className=" ">
        <div className="flex flex-wrap items-end gap-3">
          <div className="min-w-[200px]">
            <TextField
              type="text"
              name="search"
              value={formValues.search}
              onChange={handleSearchChange}
              placeholder={t("admin.search.placeholder")}
              startIcon="../media/icons/search.svg"
              cssClassName="bg-white"
            />
          </div>
          <div className="w-[150px]">
            <DatePicker
              name="expirationDateFrom"
              label="Datum isteka od - do"
              value={formValues.expirationDateFrom}
              onChange={handleDateChange}
              cssClassName="bg-white"
            />
          </div>
          <div className="w-[150px]">
            <DatePicker
              name="expirationDateTo"
              value={formValues.expirationDateTo}
              onChange={handleDateChange}
              cssClassName="bg-white"
            />
          </div>
          <div className="flex items-center pb-2">
            <span
              onClick={handleResetFormClick}
              className="text-xs font-bold cursor-pointer text-gray-700"
            >
              {t("admin.reset")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(FireExtinguisherSearchFilters);
